import React, { Fragment, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { EditData } from "./Components/Services";
import { useNavigate, useParams } from "react-router-dom";
import { Get } from "../../../../Request";
import Loading from "../../../Common/Components/Loading";

function Edit() {
  const initialState = {
    loading: false,
    need: true,
  };
  const { id } = useParams();
  const [data, setData] = useState({});
  const [state, setstate] = useState(initialState);
  const navigate = useNavigate();

  const getSingle = async id => {
    setstate({ need: true });
    await Get({
      url: "/contentbox/single",
      data: {
        content_id: id,
      },
    }).then(data => {
      setData(data);
      setstate({ need: false });
    });
  };
  useEffect(() => {
    getSingle(id);
  }, []);
  const Handler = data => {
    setstate({ loading: true });
    EditData(data).then(() => {
      setstate({
        loading: false,
      });
    });
    navigate(-1);
  };
  if (state.need) {
    return <Loading />;
  }
  let input = [
    {
      label: "انتخاب دسته بندی",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "category_id",
      input: "select",
      nested: "category",
    },
    {
      label: "انتخاب شهر",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "city_id",
      input: "select",
      nested: "cities",
    },
    {
      label: "محتوا",
      size: "col-md-12",
      classNames: "mt-2",
      name: "content",
      input: "ckeditor",
    },
    {
      label: "کلمات کلیدی سئو",
      size: "col-md-4",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoKeyword",
      input: "textarea",
    },
    {
      label: "توضیحات کلیدی سئو",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "seo",
      keyname: "seoDescription",
      input: "textarea",
    },
    {
      label: "عنوان صفحه",
      size: "col-md-12",
      classNames: "mt-2",
      name: "seo",
      keyname: "title",
      value: "",
    },
  ];
  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ویرایش باکس </title>
      </Helmet>
      <CommonFrom
        form={input}
        loading={state.loading}
        header={`ویرایش باکس `}
        textbtn="لیست باکسها"
        linkbtn="/Admin/ContentBox/List"
        btnName="ثبت ویرایش"
        submit={Handler}
        value={data}
        initialeState={{ content_id: data.id }}
        nested={["category", "cities"]}
        edit={true}
      />
    </Fragment>
  );
}

export default Edit;
